import { useCallback, useState } from 'react';
import { IMessageInfo, IMultiSuggestResult } from '@cian/geosuggest-widget';
import { path } from 'ramda';
import { debounce } from 'throttle-debounce';
import { useDispatch } from 'react-redux';
import { getYandexSuggest } from '../../../actions/geoSuggest/getYandexSuggest';

export const NOT_FOUND_ERROR: IMessageInfo = {
  title: 'Ничего не найдено',
  text: 'Укажите другой адрес',
};

export const useGeoSuggest = () => {
  const dispatch = useDispatch();

  const [isFetching, setIsFetching] = useState(false);
  const [suggestError, setSuggestError] = useState<IMessageInfo>();
  const [suggestData, setSuggestData] = useState<IMultiSuggestResult>();

  const getSuggestions = useCallback(
    async (addressChunk: string) => {
      setIsFetching(true);
      setSuggestError(undefined);

      const suggestResult: IMultiSuggestResult = await dispatch(
        (getYandexSuggest({
          request: addressChunk.trim(),
        }) as unknown) as Promise<IMultiSuggestResult>,
      );

      setIsFetching(false);

      const suggestLength = path(['suggestions', 'addresses', 'length'], suggestResult);
      if (suggestLength) {
        return setSuggestData(suggestResult);
      }

      setSuggestError(NOT_FOUND_ERROR);
      setSuggestData(undefined);
    },
    [dispatch],
  );

  const getGeoSuggestDebounced = useCallback(debounce(200, getSuggestions), [getSuggestions]);

  return {
    isFetching,
    suggestError,
    suggestData,
    getSuggestions: getGeoSuggestDebounced,
  };
};
